import { images } from '.';

const speakers = [
    {
        id: 1,
        image: images.speaker1,
        name: "Ahmed Raza",
        title: "Islamic Scholar",
        biography: "Ahmed Raza is a respected Islamic Scholar with deep knowledge in Quranic exegesis and Hadith studies. He is dedicated to guiding the community through authentic Islamic teachings and spiritual development.",
        contacts: {
            phone: "0300-1234567",
            email: "ahmed.raza@example.com",
            website: "www.ahmedraza.com",
            company: "Dar-ul-Ilm Institute",
            experience: "15+ Years in Islamic Education"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Outstanding Islamic Educator Award (2023)",
            "Author of 'Guidance Through Quran' (2021)",
            "Keynote Speaker at Global Islamic Conference (2019)"
        ],
        specialties: [
            { id: 1, title: "Quran Tafseer", progress: 95 },
            { id: 2, title: "Hadith Studies", progress: 92 },
            { id: 3, title: "Community Guidance", progress: 90 }
        ]
    },
    {
        id: 2,
        image: images.speaker2,
        name: "Fatima Noor",
        title: "Quran Teacher",
        biography: "Fatima Noor is a dedicated Quran Teacher known for her engaging teaching style and deep understanding of Tajweed. She has inspired countless students to connect with the Quran and apply its teachings in their daily lives.",
        contacts: {
            phone: "0301-2345678",
            email: "fatima.noor@example.com",
            website: "www.fatimanoorquran.com",
            company: "Al-Huda Quran Center",
            experience: "10+ Years in Quran Teaching"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Excellence in Quran Teaching Award (2022)",
            "Developed Online Quran Learning Program (2020)",
            "Keynote Speaker at Islamic Education Forum (2018)"
        ],
        specialties: [
            { id: 1, title: "Tajweed Rules", progress: 94 },
            { id: 2, title: "Quran Recitation", progress: 96 },
            { id: 3, title: "Islamic Education", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.speaker3,
        name: "Bilal Khan",
        title: "Community Leader",
        biography: "Bilal Khan is an active Community Leader committed to fostering unity and development within the local Muslim community. His initiatives focus on youth engagement, charity drives, and promoting social harmony.",
        contacts: {
            phone: "0302-9876543",
            email: "bilal.khan@example.com",
            website: "www.bilalkhancommunity.com",
            company: "United Muslim Network",
            experience: "12+ Years in Community Leadership"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Organized Annual Charity Food Drive (2024)",
            "Established Youth Leadership Program (2021)",
            "Awarded Community Impact Recognition (2019)"
        ],
        specialties: [
            { id: 1, title: "Community Outreach", progress: 93 },
            { id: 2, title: "Leadership specialties", progress: 95 },
            { id: 3, title: "Event Coordination", progress: 90 }
        ]
    },
    {
        id: 4,
        image: images.speaker4,
        name: "Maryam Ali",
        title: "Mental Therapist",
        biography: "Maryam Ali is a compassionate Mental Therapist specializing in emotional well-being and personal growth. She offers guidance on stress management, mental resilience, and overall psychological health from an Islamic perspective.",
        contacts: {
            phone: "0311-4567890",
            email: "maryam.ali@example.com",
            website: "www.maryamalitherapy.com",
            company: "Mind & Soul Wellness",
            experience: "9+ Years in Mental Health Counseling"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Founded Islamic Mental Wellness Program (2023)",
            "Conducted 100+ Therapy Workshops (2020-2024)",
            "Awarded Excellence in Counseling (2021)"
        ],
        specialties: [
            { id: 1, title: "Stress Management", progress: 94 },
            { id: 2, title: "Therapeutic Counseling", progress: 92 },
            { id: 3, title: "Emotional Intelligence", progress: 89 }
        ]
    }

];

export default speakers;